
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginForm from "./components/Login/LoginForm";
import Home from "./components/Home/Home";
import UserMaster from "./components/UserMaster/UserMaster";
import DataSource from "./components/DataSource/DataSource";
import CreateDatasource from "./components/DataSource/CreateDatasource";
import CreateUser from "./components/UserMaster/CreateUser";
import EditUser from "./components/UserMaster/EditUser";
import PulseAi from "./components/PusleAi/PulseAi";
import RegistrationForm from "./components/Registration/RegistrationForm";
import 'typeface-dm-sans';
import 'font-awesome/css/font-awesome.min.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
    }else{
      setIsLoggedIn(false);
    }
  }, []);

  //check user is logged in or not
  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsLoggedIn(false);
  };

  return (
    <>
    <Router>
      <Routes>
        <Route path="/" element={<LoginForm onLogin={handleLogin} />} />
        <Route path="/register" element={<RegistrationForm />} />
        <Route path="/home" element={<Home />} />
        {isLoggedIn ? (
          <Route
            path="/user-master"
            element={<UserMaster onLogout={handleLogout} />}
          />
        ) : null}
        {isLoggedIn ? (
          <Route
            path="/data-source"
            element={<DataSource onLogout={handleLogout} />}
          />
        ) : null}
        {isLoggedIn ? (
          <Route
            path="/create-datasource"
            element={<CreateDatasource onLogout={handleLogout} />}
          />
        ) : null}
        
        {isLoggedIn ? (
          <Route
            path="/create-user"
            element={<CreateUser onLogout={handleLogout} />}
          />
        ) : null}
        {isLoggedIn ? (
          <Route
            path="/edit-user/:id"
            element={<EditUser onLogout={handleLogout} />}
          />
        ) : null}
        {isLoggedIn ? (
          <Route
            path="/pulse-ai"
            element={<PulseAi onLogout={handleLogout} />}
          />
        ) : null}
      </Routes>
    </Router>
    </>
  );
}

export default App;